
    //import { AutoComplete } from "ant-design-vue";
    import Vue from "vue";

    import { Component, Prop, Watch } from "vue-property-decorator";
    import { Menu, Input, Dropdown } from "ant-design-vue";
    import { SearchinStore } from "@/UI/Decorators/decorator";
    import parsePhoneNumber from "libphonenumber-js";
    import { AsYouType } from "libphonenumber-js";
    import Inputmask from "inputmask";

    @Component({
        components: {
            "a-menu-item": Menu.Item,
            "a-menu": Menu,
            "a-input-search": Input.Search,
            "a-dropdown": Dropdown,
        },
        methods: { parsePhoneNumber, Inputmask },
    })
    export default class EAutoComplete extends Vue {
        @Prop({ required: true }) readonly source!: string;
        @Prop() phone!: string;
        //@Prop({ required: true }) id!: number | string;
        @Prop() form!: any;
        @Prop() disabled!: boolean;

        clicked = false;
        hovered = false;

        phoneDta = this.phone;
        showDropDown: boolean = false;

        handleClickChange(visible: boolean): void {
            this.showDropDown = visible;
            this.hovered = false;
        }

        @Watch("this.form")
        setFormData(): void {
            this.phoneDta = this.form["client_phone"];
        }

        @SearchinStore
        hSearch(source: string, value: string, useStudio: boolean, name?: string, filter?: any): void {
            this.phoneDta = this.form["client_phone"];
            this.$emit("setPhone", this.phoneDta);
        }

        handleSearchWithName(source: string, value: string, useStudio: boolean, name: string): void {
            this.hSearch(source, value, useStudio, name);
        }

        mounted(): void {
            Inputmask.extendDefaults({
                autoUnmask: true,
            });
            const im = new Inputmask(" +[9-(999)-999-99-99]");
            im.mask(this.$refs["eAutoComplete"] as HTMLElement);

            //im.mask(document.getElementById('test-field'));
        }

        searchPhone(value: any): void {
            this.handleSearchWithName(this.source, value, true, "phone");
        }

        phoneNum(data: string): string {
            return new AsYouType().input('+' + String(data).replace(/\D/g, '')).replace(/^\+/, '');
        }

        setData(client: any): void {
            this.form["client_id"] = client["id"];
            this.form["client_name"] = client["name"];
            this.form["client_phone"] = client["phone"];
            this.form["client_source"] = client["source"];

            this.form["new_client"] = false;
            this.phoneDta = client["phone"];
            this.showDropDown = false;

            this.$emit("setData", client);
        }

        SearchData(value: any): void {

            this.form["client_id"] = 0;
            this.form["new_client"] = true;
            const dta = new AsYouType("RU");
            dta.input(value);

            const search = dta.getChars().replace("+", "");

            setTimeout(() => {
                this.searchPhone(search);
                this.showDropDown = true;
            }, 300);
        }
    }
